import { render, staticRenderFns } from "./FloatAside.vue?vue&type=template&id=d118f140&scoped=true&"
import script from "./FloatAside.vue?vue&type=script&lang=js&"
export * from "./FloatAside.vue?vue&type=script&lang=js&"
import style0 from "./FloatAside.vue?vue&type=style&index=0&id=d118f140&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d118f140",
  null
  
)

export default component.exports